import { render, staticRenderFns } from "./albumCard.vue?vue&type=template&id=38ea83f1&scoped=true&"
import script from "./albumCard.vue?vue&type=script&lang=js&"
export * from "./albumCard.vue?vue&type=script&lang=js&"
import style0 from "./albumCard.vue?vue&type=style&index=0&id=38ea83f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea83f1",
  null
  
)

export default component.exports